export default "__VITE_ASSET__rc_45JnR__"